// src/router/asyncRoutes.js
import BlankLayout from "@/views/layouts/BlankLayout.vue";

export const asyncRoutes = [
  {
    path: "user-master",
    component: BlankLayout,
    meta: {
      title: "企业与师傅管理",
      menu: true,
      icon: "el-icon-s-custom",
      permission: "user-master-management",
    },
    children: [
      {
        path: "enterprise",
        name: "Enterprise",
        component: () => import("@/views/userMaster/Enterprise.vue"),
        meta: {
          title: "企业管理",
          icon: "el-icon-office-building",
          permission: "enterprise",
        },
      },
      {
        path: "master",
        name: "Master",
        component: () => import("@/views/userMaster/Master.vue"),
        meta: { title: "师傅管理", icon: "el-icon-user", permission: "master" },
      },
    ],
  },
  {
    path: "user",
    component: BlankLayout,
    meta: {
      title: "用户管理",
      menu: true,
      icon: "el-icon-user-solid",
      permission: "user-management",
    },
    children: [
      {
        path: "list",
        name: "UserList",
        component: () => import("@/views/user/UserList.vue"),
        meta: {
          title: "用户列表",
          permission: "user-list",
          icon: "el-icon-user",
        },
      },
    ],
  },

  {
    path: "service-project",
    component: BlankLayout,
    meta: {
      title: "服务项目管理",
      menu: true,
      icon: "el-icon-shopping-bag-1",
      permission: "service-project-management",
    },
    children: [
      {
        path: "type-management",
        name: "TypeManagement",
        component: () => import("@/views/serviceProject/TypeManagement.vue"),
        meta: {
          title: "服务项目",
          permission: "type-management",
          icon: "el-icon-shopping-bag-2",
        },
      },
    ],
  },
  {
    path: "settlement-reconciliation",
    component: BlankLayout,
    meta: { title: "结算与对账", menu: true, icon: "el-icon-s-finance" },
    children: [
      {
        path: "settlement-list",
        name: "SettlementList",
        component: () =>
          import("@/views/settlementReconciliation/settlementList.vue"),
        meta: {
          title: "结算列表",
          icon: "el-icon-s-claim",
          permission: "settlement-list",
        },
      },
      {
        path: "reconciliation-list",
        name: "ReconciliationList",
        component: () =>
          import("@/views/settlementReconciliation/reconciliationList.vue"),
        meta: {
          title: "对账列表",
          icon: "el-icon-s-order",
          permission: "reconciliation-list",
        },
      },
    ],
  },
  {
    path: "order-management",
    component: BlankLayout,
    meta: { title: "订单管理", menu: true, icon: "el-icon-notebook-2" },
    children: [
      {
        path: "order-list",
        name: "OrderList",
        component: () => import("@/views/orderManagement/orderList.vue"),
        meta: {
          title: "订单列表",
          icon: "el-icon-tickets",
          permission: "order-list",
        },
      },
      {
        path: "need-list",
        name: "NeedList",
        component: () => import("@/views/orderManagement/needList.vue"),
        meta: {
          title: "需求列表",
          icon: "el-icon-receiving",
          permission: "need-list",
        },
      },
    ],
  },
  {
    path: "invoice-management",
    component: BlankLayout,
    meta: { title: "发票管理", menu: true, icon: "el-icon-postcard" },
    children: [
      {
        path: "invoice-list",
        name: "InvoiceList",
        component: () => import("@/views/invoice/list.vue"),
        meta: {
          title: "发票列表",
          icon: "el-icon-postcard",
          permission: "invoice-list",
        },
      },
    ],
  },
  {
    path: "system",
    component: BlankLayout,
    meta: {
      title: "系统设置",
      menu: true,
      icon: "el-icon-setting",
      permission: "system-management",
    },
    children: [
      {
        path: "role",
        name: "RoleManagement",
        component: () => import("@/views/system/RoleManagement.vue"),
        meta: {
          title: "角色管理",
          permission: "role-management",
          icon: "el-icon-user-solid",
        },
      },
      {
        path: "dispatch",
        name: "DispatchManagement",
        component: () => import("@/views/system/DispatchManagement.vue"),
        meta: {
          title: "派单设置",
          permission: "dispatch-management",
          icon: "el-icon-s-tools",
        },
      },
    ],
  },
];
